'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var TextLink = require('@narvar/nth-bit-text-link');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookTheme = require('@narvar/nth-hook-theme');
var React = require('react');
var RefreshIcon = require('../icons/RefreshIcon.js');
var TrackingEventsLastUpdated_module = require('./TrackingEventsLastUpdated.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function TrackingEventsLastUpdated({
  carrier,
  trackingNumber,
  featureName,
  latestEvent,
  isFetching = false,
  onClick
}) {
  const {
    captiontextDefaultNone
  } = nthHookTheme.useTheme();
  const [isSpinning, setIsSpinning] = React.useState(false);
  const {
    date: latestEventDate,
    dateFormatted
  } = latestEvent;
  const [dateFormattedDate, formattedTime] = dateFormatted;
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();

  // NOTE: This is purely for the spinner animation to allow it to rotate at
  //       least one time.  Just makes the UX feel nicer on faster connections.
  React.useEffect(() => {
    if (!isSpinning) return;
    const interval = setInterval(() => {
      if (!isFetching) setIsSpinning(false);
    }, 750);
    return () => clearInterval(interval);
  }, [isFetching, isSpinning]);
  if (!latestEventDate) return null;
  const getFormattedDate = () => {
    const eventDate = new Date(latestEventDate);
    const now = new Date();
    const diff = eventDate.getUTCDate() - now.getUTCDate();

    // FIXME: Replace hard coded text with translation keys
    if (diff === 0) return 'Today';
    if (diff === -1) return 'Yesterday';
    const [, date] = dateFormattedDate.split(',');
    return date.trim();
  };
  const formattedDate = getFormattedDate();
  const handleClick = () => {
    setIsSpinning(true);
    onClick();
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.REFRESH_SHIPPING_HISTORY,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.REFRESH_SHIPPING_HISTORY,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventCarrierMoniker: carrier,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_SHIPPING_ACTIVITY,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_SHIPPING_ACTIVITY,
      eventTrackingNumber: trackingNumber,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_SHIPPING_ACTIVITY
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    onClick: handleClick,
    linkStyle: {
      sDefault: {
        ...captiontextDefaultNone
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: TrackingEventsLastUpdated_module["default"].refreshContainer
  }, /*#__PURE__*/React__default["default"].createElement("span", null, formattedDate), ",\xA0", /*#__PURE__*/React__default["default"].createElement("time", null, formattedTime), /*#__PURE__*/React__default["default"].createElement("div", {
    className: TrackingEventsLastUpdated_module["default"].refreshIconWrapper
  }, /*#__PURE__*/React__default["default"].createElement(RefreshIcon.RefreshIcon, {
    isLoading: isSpinning
  }))));
}
function themeProvider(component) {
  return nthHookTheme.withThemeProvider(component, {
    themeTokens: ['captiontextDefaultNone']
  });
}
var TrackingEventsLastUpdated$1 = themeProvider(TrackingEventsLastUpdated);

exports["default"] = TrackingEventsLastUpdated$1;
